import React from 'react'

export const Top = props => <svg
	{...props}
	preserveAspectRatio='none'
	width="100%"
	height="108"
	viewBox="0 0 1440 108"
	fill="none"
	xmlns="http://www.w3.org/2000/svg">
	<path
		fill-rule="evenodd"
		clip-rule="evenodd"
		d="M1440 0H0V65.7862C67.0842 39.4007 299.426 -37.2579 599.254 27.6155C672.034 43.3628 730.274 57.2496 778.908 68.8459C969.109 114.198 1012.38 124.515 1203.8 74.0669C1299.92 48.7369 1379.32 30.7023 1440 18.1787V0Z"
		fill="white"/>
</svg>

export const Bottom = props => <svg
	{...props}
	preserveAspectRatio='none'
	width="100%"
	height="68"
	viewBox="0 0 1440 68"
	fill="none"
	xmlns="http://www.w3.org/2000/svg">
	<path
		fill-rule="evenodd"
		clip-rule="evenodd"
		d="M1298.4 7.01008C1345.7 17.7914 1395.58 34.6166 1440 51.7114V68.0001H0V54.5882C6.82137 53.4289 13.89 52.2137 21.178 50.9608L21.2513 50.9481C98.9001 37.5986 201.429 19.9717 295.09 19.9717C364.637 19.9717 426.722 29.6903 493.606 40.16C571.694 52.3836 656.322 65.631 767 65.631C862.06 65.631 954.876 46.6973 1040.14 29.3035C1139.18 9.09986 1228.04 -9.02612 1298.4 7.01008Z"
		fill="white"/>
</svg>

